import { render } from "./MyProjects.vue?vue&type=template&id=0a2e418c&scoped=true"
import script from "./MyProjects.vue?vue&type=script&lang=js"
export * from "./MyProjects.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src286570729/src/astaykov-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2e418c"]])

export default __exports__